import React, { useEffect, useState } from 'react';
import './cart.css';
import { useSelector, useDispatch } from 'react-redux';
import {
  AddToCart,
  EmptyCart,
  RemoveAddOnFromCart,
  Decrease_Qnty,
  getTotal
} from '../statemanagement/actions/cart';
import Collapse from 'react-bootstrap/Collapse';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Lottie from 'lottie-react';
import Animation1 from "./CheckMarkAnimation.json"
import Animation2 from "./ErrorAnimation.json"
import { Button } from 'react-bootstrap';
import { domain } from '../domain';

export const Cart = ({ Checkout }) => {
  const { cart, total } = useSelector((state) => state.CartReducer);
  const dispatch = useDispatch();
  const [message, setMessage] = useState('success');
  const [status12, setStatus] = useState('unset');
  const [table, setTable] = useState('1');
  const [open, setOpen] = useState('');

  useEffect(() => {
    dispatch(getTotal());
  }, [dispatch, total]);

  const RenderTotal = () => parseFloat(total).toFixed(2);

  async function makeOrder() {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const order_items = cart.map((item) => ({
      name: item.name,
      quantity: item.quantity,
      type: item.type,
      price: item.price,
      additional_products: item.selectedAddOns.map((addon) => ({
        name: addon.name,
        price: addon.price
      }))
    }));

    const raw = JSON.stringify({
      details: `Order from table ${table}`,
      is_delivered: false,
      tableId: parseInt(table),
      total: parseFloat(total),
      order_items
    });

    try {
      const response = await fetch(`${domain}/api/order/`, {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      });
      const result = await response.json();
      if (result.id) {
        setStatus('success');
        setMessage("Siparişiniz başarıyla oluşturuldu, Lütfen garsonlarımızın masanıza gelmesini bekleyin.");
        dispatch(EmptyCart());
      } else {
        throw new Error();
      }
    } catch (error) {
      setStatus('error');
      setMessage("Sipariş oluşturulamadı. Lütfen tekrar deneyin.");
    }
  }

  if (status12 !== 'unset') {
    return (
      <div className="sticky-cart">
        <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100%' }}>
          {status12 === 'success' && <Lottie style={{ maxWidth: 400 }} animationData={Animation1} />}
          {status12 === 'error' && <Lottie style={{ maxWidth: 400 }} animationData={Animation2} />}
          {message && <h6 className="text-center">{message}</h6>}
        </div>
      </div>
    );
  }

  return (
    <div className="sticky-cart">
      {cart.length === 0 ? (
        <table className="table cart-table mb-0">
          <tbody>
            <tr>
              <td colSpan="6">
                <div className="cart-empty">
                  <i className="fa fa-shopping-cart"></i>
                  <p>Sepetiniz boş</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      ) : (
        <div className="table-responsive-xl">
          <div className="card-header bg-dark p-2">
            <div className="card-header-flex">
              <h5 className="text-white m-0">Sepetim</h5>
              <button
                className="btn btn-danger mt-0 btn-sm mb-0"
                onClick={() => dispatch(EmptyCart())}
              >
                <i className="fa fa-trash-alt mr-2"></i>
                <span>Sepeti Boşalt</span>
              </button>
            </div>
          </div>

          <table className="card table cart-table mb-0">
            <tbody>
              {cart.map((data) => {
                const { id, name, price, quantity, selectedAddOns } = data;
                const basePrice = parseFloat(price) || 0;
                const itemAddOnPrice = selectedAddOns?.reduce((acc, a) => acc + parseFloat(a.price || 0), 0) || 0;
                const itemTotalPrice = (basePrice + itemAddOnPrice) * quantity;

                return (
                  <React.Fragment key={id}>
                    <tr>
                      <td colSpan="3">
                        <p className="product-name">{name}</p>
                      </td>
                      <td colSpan="3">
                        <div className="prdct-qty-container">
                          <button className="prdct-qty-btn" onClick={() => dispatch(Decrease_Qnty(id))}>
                            <i className="fa fa-minus"></i>
                          </button>
                          <input type="text" className="qty-input-box" value={quantity} disabled />
                          <button className="prdct-qty-btn" onClick={() => dispatch(AddToCart(data))}>
                            <i className="fa fa-plus"></i>
                          </button>
                        </div>
                      </td>
                      <td colSpan="3">{itemTotalPrice.toFixed(2)}₺</td>
                      <td>
                        <Button
                          className="btn btn-secondary"
                          onClick={() => setOpen(open === id ? '' : id)}
                        >
                          {open === id ? "▴" : "▾"}
                        </Button>
                      </td>
                    </tr>
                    {selectedAddOns?.length > 0 && (
                      <tr>
                        <td colSpan="12" className="pt-0">
                          <Collapse in={open === id}>
                            <div>
                              <ul className="list-unstyled mb-0">
                                {selectedAddOns.map((addOn, idx) => (
                                  <li key={idx}>
                                    <button
                                      className="btn btn-sm btn-danger me-2 my-1"
                                      onClick={() => dispatch(RemoveAddOnFromCart(id, addOn.name))}
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                    {addOn.name} ({addOn.price}₺)
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </Collapse>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}

              <tr>
                <th colSpan="6" className="text-left w-100">
                  Toplam<span className="ml-1 mr-2">:</span>
                  <span className="text-danger">{RenderTotal()} ₺</span>
                  <div>
                    <DropdownButton
                      id="dropdown-basic-button"
                      title={`Seçilen Masa: ${table}`}
                      variant="danger"
                    >
                      {[1, 2, 3, 4, 5, 6, 7].map((num) => (
                        <Dropdown.Item key={num} onClick={() => setTable(String(num))}>
                          Masa {num}
                        </Dropdown.Item>
                      ))}
                    </DropdownButton>
                  </div>
                </th>
                <th colSpan="4">
                  <button className="mt-0 check-btn" onClick={makeOrder}>
                    <span>{ 'Sipariş Ver'}</span>
                  </button>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
